export function makeNumberIntoString(
  value: number,
  indicator?: string
): string {
  return value.toString() + indicator;
}
